import { Company } from './company';

export class SystemCompany extends Company {
    public broker_name: string;
    public broker_commission: string;
    public sales_representative: string;
}
